<template>
    <footer class="footer inverted" role="contentinfo">
        <div class="mx-auto max-w-[1440px] p-[50px]">
            <div class="flex flex-row">
                <div class="w-1/3 footer-menu">
                    <h3>Eliquis</h3>
                    <div>
                        <nav role="navigation" aria-labelledby="block-footer-menu" id="block-footer">
                            <ul>
                                <!-- <li>
                                    <a href="//www.eliquis.se/om-eliquis" data-drupal-link-system-path="node/23"
                                       sc:linkname="global footer | navigation | om eliquis">Om Eliquis</a>
                                </li> -->
                                <li>
                                    <a href="//www.eliquis.se/aktuellt" data-drupal-link-system-path="aktuellt"
                                       sc:linkname="global footer | navigation | aktuellt">Aktuellt</a>
                                </li>
                                <li>
                                    <a href="//www.eliquis.se/kontakt" data-drupal-link-system-path="node/60"
                                       sc:linkname="global footer | navigation | kontakt">Kontakt</a>
                                </li>
                                <li>
                                    <a href="//www.eliquis.se/material" data-drupal-link-system-path="node/3"
                                       sc:linkname="global footer | navigation | material">Material</a>
                                </li>
                                <!-- <li>
                                    <a href="//www.eliquis.se/utbildning" data-drupal-link-system-path="node/72"
                                       sc:linkname="global footer | navigation | utbildning">Utbildning</a>
                                </li> -->
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="w-1/3 footer-content">
                    <div>
                        <div id="block-footercontent">
                            <div>
                                <h3>Håll dig uppdaterad</h3>
                                <p>Registrera dig för nyhetsbrevet för att hålla dig uppdaterad och få information som
                                    du har nytta av i din vardag.</p>
                                <p><a class="btn orange" href="//www.eliquis.se/nyhetsbrev"
                                      sc:linkname="global footer | navigation | registrera dig">Registrera dig</a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-1/3 footer-share">
                    <div class="content">
                        <h3>Dela sidan</h3>
                        <div class="share-links">
                            <!-- Facebook -->
                            <a href="http://www.facebook.com/sharer.php?u=https://www.eliquis.se/startsida"
                               target="_blank" sc:linkname="facebook">
                                <img src="//www.eliquis.se/themes/custom/eliquis/assets//images/facebook-white.svg"
                                     alt="Share on Facebook">
                            </a>
                            <!-- Twitter -->
                            <a href="https://twitter.com/share?url=https://www.eliquis.se/startsida&amp;text=Eliquis.se&amp;hashtags=eliquis"
                               target="_blank" sc:linkname="twitter">
                                <img src="//www.eliquis.se/themes/custom/eliquis/assets//images/twitter-white.svg"
                                     alt="Share on Twitter">
                            </a>
                            <!-- Email -->
                            <a href="mailto:?subject=Eliquis.se&amp;body=Hej!%20https://www.eliquis.se/startsida"
                               sc:linkname="email">
                                <img src="//www.eliquis.se/themes/custom/eliquis/assets//images/share-white.svg"
                                     alt="Share with Email">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-row mt-4 gap-4">
                <div class="w-1/3 self-center footer-lefttext">
                    <div>
                        <div id="block-footertextleft">
                            <div v-if="showBlocks && blocks.gcma" v-html="blocks.gcma.body" class="text-[12px] font-thin">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-1/3 self-center footer-middletext">
                    <div>
                        <div id="block-footertextmiddle">
                            <div v-if="showBlocks && blocks.links" v-html="blocks.links.body" class="text-[12px] font-thin">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-1/3 self-center footer-links">
                    <img src="//www.eliquis.se/themes/custom/eliquis/assets/images/footer_logos_inverted.svg"
                         alt="Logos">
                    <div>
                        <nav role="navigation" aria-labelledby="block-footeradditionallinks-menu"
                             id="block-footeradditionallinks">
                            <ul>
                                <li>
                                    <a href="https://privacycenter.pfizer.com/sv/sweden#cookies">Om cookies</a>
                                </li>
                                <li>
                                    <a href="http://www.fass.se/LIF/product?userType=0&amp;nplId=20111026000050">Produktinformation/bipacksedel
                                        i FASS</a>
                                </li>
                                <li>
                                    <a href="https://www.bms.com/se/privacy-policy.html">Så behandlar vi
                                        personuppgifter</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="flex-grid footer-bottom mt-4">
                <div id="block-footertextbottom">
                    <div v-if="showBlocks && blocks.copyright" v-html="blocks.copyright.body" class="text-[12px] font-thin">
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import {XCircleIcon, CheckCircleIcon} from '@heroicons/vue/solid'
import axios from 'axios'

export default {
    name: 'FooterBlock',
    components: {
        CheckCircleIcon,
        XCircleIcon
    },
    props: {
        classname: String
    },
    data() {
        return {
          blocks: [],
          showBlocks: false
        }
    },
    setup() {
    },
    methods: {
        getFooterBlocks() {
            axios.get('/api/eliquis-footer-blocks')
              .then(response => {
                  if(response.data) {
                      this.blocks = response.data;
                      this.showBlocks = true;
                  }
              })
              .catch(error => {
                  console.log(error);
              });
        },
    },
    mounted() {
        this.getFooterBlocks();
    }
}
</script>
<style>

@font-face {
    font-family: 'FSJoey';
    src: url(/fonts/FSJoey-Light.otf) format("opentype");
    font-weight: 100 300;
}

@font-face {
    font-family: 'FSJoey';
    src: url(/fonts/FSJoey-Medium.otf) format("opentype");
    font-weight: 400 500;
}

@font-face {
    font-family: 'FSJoey';
    src: url(/fonts/FSJoey-Bold.otf) format("opentype");
    font-weight: 600 1000;
}

footer {
    background: #46113f;
    background: linear-gradient(90deg, #4f1d48, #5f0f32 60%, #2b051a), linear-gradient(0deg, #2c051a, #e6262a 30%, transparent 80%);
    background-blend-mode: multiply;
    min-height: 40vh;
    color: white;
    font-family: FSJoey, Helvetica, Arial, sans-serif;
}

footer p {
    font-size: calc(16px + 2*(min(100vw, 1440px) - 375px) / 905);
    line-height: 1.5;
}


footer .flex-grid {
    display: flex;
}

footer .flex-grid .col {
    flex: 1 1 25%;
    padding: 10px;
}

@media (min-width: 769px) {
    footer {
        padding: 30px
    }
}

footer a, footer p {
    font-weight: 100
}

footer p {
    margin-bottom: 12px;
}

footer h5 {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 0
}

footer h3 {
    font-family: FSJoey, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: calc(26px + 2 * (100vw - 375px) / 905);
    margin-bottom: 20px;
}

footer a {
    text-decoration: none;
    color: white;
}

footer a:hover {
    text-decoration: underline
}

.footer-menu ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: calc(14px + 2*(100vw - 375px)/905);
}

.footer-menu ul li {
    flex: 1 1 50%;
    margin-bottom: 10px;
}

.footer-menu ul li a {
    text-decoration: none
}

.footer-menu ul li a:hover {
    text-decoration: underline
}

#block-footercontent {
    font-size: 16px;
}

.footer-middle p {
    font-size: 12px
}

.footer-share {
    display: flex;
    align-items: flex-start
}

.footer-share > div {
    flex: 0 1 auto
}

.footer-share .share-links a {
    display: inline-block;
    margin-right: 0.5rem;
    transition: opacity .2s ease;
}

@media (min-width: 992px) {
    .footer-share {
        justify-content: center
    }
}

.footer-lefttext.col {
    flex: 1 1 33%
}

.footer-middletext.col {
    flex: 1 1 23%
}

.footer-links ul {
    display: flex;
    flex-direction: row;
    margin-top: 15px;   
    /*-Justify space betwwen*/
    justify-content: space-between;
}

@media (max-width: 1350px) {
    .footer-links ul {
        flex-direction: column;
        text-align: left;
    }

    .footer-links ul li {
        margin-bottom: 5px;
    }
}

.footer-lefttext p, .footer-middletext p, .footer-links {
    font-size: 12px;
    font-weight: 100;
}

.footer-links.col ul li a {
    font-size: 12px
}

.footer-bottom p {
    font-size: 12px;
    max-width: none;
    margin: 0
}

.footer-bottom a {
    color: white !important;
}

.footer-bottom img {
    margin-bottom: 20px
}

footer .btn.orange {
    display: inline-block;
    padding: 0.6em 1.6em;
    margin-top: 20px;
    margin-right: 10px;
    border-radius: 0;
    text-decoration: none;
    color: #fff;
    cursor: pointer;
    font-weight: 500;
    background-color: #821257;
    transition: all .2s ease;
    border: 0;
    min-width: 160px;
    text-align: center;
    background-color: #fa8500;
}

.footer-lefttext.col {
    flex: 1 1 33%;
}

.footer-middletext.col {
    flex: 1 1 23%;
}

.footer-links.col {
    flex: 1 1 43%;
    text-align: center;
}
</style>